import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

export interface SelectOption {
    label: string; value: string
}

export type OptionsSelect = SelectOption[];

@Component({
    selector: 'ashcorp-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AshcorpSelectComponent {
    @Input() form!: FormGroup;
    @Input() label = '';
    @Input() name = '';
    @Input() required = false;
    @Input() options: OptionsSelect = [];

    id: string = "";

    constructor() {
        this.id = `select-${this.name}`.toLocaleLowerCase().replace(/[^a-z0-9]+/g, '-');
    }

    get control(): AbstractControl | null {
        if (!this.form || !this.name) {
            return null;
        }

        return this.form.get(this.name);
    }

    get errorMessage(): string {
        const control = this.control;
        if (!control) {
            return '';
        }

        const serverError = control.getError('server');
        if (serverError) {
            return serverError;
        }

        if (control.hasError('required')) {
            return `${this.label || this.name} is required.`;
        }

        return '';
    }
}
